module.exports = __webpack_public_path__ + "img/effect_mode2.752465f4.svg";